__webpack_require__.p = "/flexteck_react_practical/";